import { IListResponse, XHRInstance } from "@sembark-travel/xhr"
import { IPaymentPreference } from "../store"
import { ServiceType } from "../../Supplier"

export function hotelPaymentPreferencesXHR(xhr: XHRInstance) {
	return {
		async getHotelPaymentPreferences(
			params?: Record<string, string | number | undefined>
		): Promise<IListResponse<IPaymentPreference>> {
			return xhr
				.get("/supplier-payment-preferences", {
					params: { ...params, service_type: ServiceType.HotelBookingServices },
				})
				.then((resp) => resp.data)
		},
		async getHotelPaymentReferences(
			params?: Record<string, string | number | undefined>
		): Promise<IListResponse<{ id: number; name: string }>> {
			return xhr
				.get("/supplier-payment-preferences/references", {
					params: { ...params, service_type: ServiceType.HotelBookingServices },
				})
				.then((resp) => resp.data)
		},
	}
}
